// extracted by mini-css-extract-plugin
module.exports = {"home":"page_home___A5fg","height32":"page_height32__yfMet"};